import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './styles/main.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import toastConfigs from './toast.configs.tsx';
import { ThemeProvider } from '@emotion/react';
import MuiTheme from '@/mui.config.ts';
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';
import * as Sentry from '@sentry/react';
import { Error } from './shared/ui';
import { CacheProvider } from '@emotion/react';
import { myCache } from './emotionCacheConf.ts';
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { CookiesProvider } from 'react-cookie';
import { setAxiosInterceptors } from './shared/services/http/interceptors.ts';
import { http as axiosInstance } from './shared/services/http';

setAxiosInterceptors(axiosInstance);

// comment to test semantic release
const gtmParams = { id: import.meta.env.VITE_APP_GTM_ID || '' };
const posthogHost = import.meta.env.VITE_APP_POST_HOG_HOST || '';
const posthogKey = import.meta.env.VITE_APP_POST_HOG_ID || '';
posthog.init(posthogKey, { api_host: posthogHost, capture_pageview: false, persistence: 'sessionStorage' as 'memory' | 'localStorage' | 'cookie' | 'localStorage+cookie' | 'sessionStorage' | undefined });
window.posthog = posthog;

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <CookiesProvider>
            <PostHogProvider client={posthog}>
                <CacheProvider value={myCache}>
                    <GTMProvider state={gtmParams}>
                        <ToastContainer {...toastConfigs} />
                        <ThemeProvider theme={MuiTheme}>
                            <Sentry.ErrorBoundary onError={e => console.log(e)} fallback={<Error />}>
                                <App />
                            </Sentry.ErrorBoundary>
                        </ThemeProvider>
                    </GTMProvider>
                </CacheProvider>
            </PostHogProvider>
        </CookiesProvider>
    </React.StrictMode>
);
